import React from 'react'

function ScreenLoaderHome() {
  return (
    <>
    

    <div className="pos-main">

      <div className="pos-center home">

        <span className="loader-home">
        </span>
        
    <span className='loading'>Loading...</span>
  
      </div>
   
    </div>


    </>

  )
}

export default ScreenLoaderHome
